export class TicketDatumViewModel {

    kioskId: string;
    tenantId: string;
    estimatedRemaining: number;
    created: Date;
    localTimeStamp: Date;
    timezoneOffset: number;
    timeZone: string;
}